import { render, staticRenderFns } from "./CruiseDetailRow.vue?vue&type=template&id=0b5d4562&scoped=true"
import script from "./CruiseDetailRow.vue?vue&type=script&lang=js"
export * from "./CruiseDetailRow.vue?vue&type=script&lang=js"
import style0 from "./CruiseDetailRow.vue?vue&type=style&index=0&id=0b5d4562&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5d4562",
  null
  
)

export default component.exports